import { AtlBrowserStorageLocal } from '@atlassian/browser-storage-controls/web-storage-service';

const STORAGE_KEY_PREFIX = 'studio.gsn.recentAgents';

export const getRecentAgents = (cloudId: string): string[] => {
	try {
		const storedAgentIds = AtlBrowserStorageLocal.getItem(`${STORAGE_KEY_PREFIX}.${cloudId}`);
		if (!storedAgentIds) {
			return [];
		}

		const parsedAgentIds: unknown = JSON.parse(storedAgentIds);
		return Array.isArray(parsedAgentIds)
			? parsedAgentIds.filter((agentId): agentId is string => typeof agentId === 'string')
			: [];
	} catch {
		return [];
	}
};
